import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'
import { routePaths } from '../../urls'
import CanvasSetup from './Setup'
import CanvasAuthorize from './Authorize'
import CanvasReview from './Review'
import CanvasChoose from './Choose'
import CreateTool from './CreateTool'
import OptionalActions from './OptionalActions.js'

const Canvas = () => {
  return (
    <div>
      <Route path={routePaths.canvasAuthorize} component={CanvasAuthorize} />
      <Route path={routePaths.canvasReview} component={CanvasReview} />
      <Route path={routePaths.canvasSetup} component={CanvasSetup} />
      <Route path={routePaths.canvasChooseCourse} component={CanvasChoose} />
      <Route path={routePaths.canvasCreateTool} component={CreateTool} />
      <Route
        path={routePaths.canvasOptionalActions}
        component={OptionalActions}
      />

      <Route
        exact
        path={routePaths.canvas}
        render={() => <Redirect to={routePaths.canvasSetup} />}
      />
    </div>
  )
}

Canvas.propTypes = {
  match: PropTypes.object,
}

export default Canvas
